import React from 'react';
import ReactCamera, { FACING_MODES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';

import { Icon } from '@fluentui/react';

const Overlay = () => {
    return (
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            background: "#000",
            opacity: "0.9"
        }}>
        </div>
    )
};
//export const CloseContainer = styled.div`

//  & i:hover {
//    box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.15);
//  }
//`;

interface Props {
    isOpen: boolean;
    closeCamera: (bool: boolean) => void;
    takePhoto: (base64: string) => void;
};

const Camera = ({ isOpen, closeCamera, takePhoto }: Props) => {
    return (
        <React.Fragment>
            {
                isOpen &&
                <div id="CameraContainer" style={{
                        zIndex: 100,
                        position: "fixed",
                        top: 0,
                        left: 0,
                        height: "100vh",
                        width: "100vw",
                        display: "flex"
                    }}>
                    <Overlay />
                        <div
                            onClick={() => closeCamera(false)}
                            style={{
                                position: "absolute",
                                right: 50,
                                top: 50,
                                height: 30,
                                width: 30,
                                cursor: "pointer",
                                zIndex: 1001
                            }}>
                        <Icon iconName="ChromeClose"
                            style={{ fontSize: 30, color: '#fff' }} />
                        </div>
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                            <ReactCamera
                            
                                idealFacingMode={FACING_MODES.ENVIRONMENT}
                                isImageMirror={false}
                                imageCompression={1}
                                isMaxResolution={true}
                                onTakePhoto={(dataUri: string) => {
                                    takePhoto(dataUri);
                                }}
                                idealResolution={{ width: 500, height: 280 }}
                            />
                    </div>

                </div>
            }
        </React.Fragment>
    );
};

export default Camera;
